import {
  INVOICE_WITHHOLDING_TAX_CONDITION,
  INVOICE_WITHHOLDING_TYPE,
} from "@letsbit/malcolmlb";
import { defineMessages } from "react-intl";
import { INVOICE_LOCAL_PAGE_TYPE } from "./types";

export const scope = "components.HistoryDetails.components.InvoiceLocal";

export const messages = defineMessages({
  [INVOICE_WITHHOLDING_TYPE.AFIP_A]: {
    id: `${scope}.${INVOICE_WITHHOLDING_TYPE.AFIP_A}`,
    defaultMessage: "A",
  },
  [INVOICE_WITHHOLDING_TYPE.AFIP_B]: {
    id: `${scope}.${INVOICE_WITHHOLDING_TYPE.AFIP_B}`,
    defaultMessage: "B",
  },
  [INVOICE_WITHHOLDING_TYPE.AFIP_C]: {
    id: `${scope}.${INVOICE_WITHHOLDING_TYPE.AFIP_C}`,
    defaultMessage: "C",
  },
  // Should not be posible
  [INVOICE_WITHHOLDING_TYPE.FOREIGN]: {
    id: `${scope}.${INVOICE_WITHHOLDING_TYPE.FOREIGN}`,
    defaultMessage: "Invalid",
  },

  [INVOICE_LOCAL_PAGE_TYPE.INVOICE]: {
    id: `${scope}.${INVOICE_LOCAL_PAGE_TYPE.INVOICE}`,
    defaultMessage: "Factura",
  },
  [INVOICE_LOCAL_PAGE_TYPE.CREDIT_NOTE]: {
    id: `${scope}.${INVOICE_LOCAL_PAGE_TYPE.CREDIT_NOTE}`,
    defaultMessage: "Nota de crédito",
  },

  [INVOICE_WITHHOLDING_TAX_CONDITION.EXEMPT]: {
    id: `${scope}.${INVOICE_WITHHOLDING_TAX_CONDITION.EXEMPT}`,
    defaultMessage: "Exento",
  },
  [INVOICE_WITHHOLDING_TAX_CONDITION.FINAL_CONSUMER]: {
    id: `${scope}.${INVOICE_WITHHOLDING_TAX_CONDITION.FINAL_CONSUMER}`,
    defaultMessage: "Consumidor Final",
  },
  [INVOICE_WITHHOLDING_TAX_CONDITION.REGISTERED_REPONSIBLE]: {
    id: `${scope}.${INVOICE_WITHHOLDING_TAX_CONDITION.REGISTERED_REPONSIBLE}`,
    defaultMessage: "Responsable Inscripto",
  },
  [INVOICE_WITHHOLDING_TAX_CONDITION.SINGLETAX]: {
    id: `${scope}.${INVOICE_WITHHOLDING_TAX_CONDITION.SINGLETAX}`,
    defaultMessage: "Monotributista",
  },

  legalText: {
    id: `${scope}.legalText`,
    defaultMessage:
      "Comprobante emitido conforme R.G. 2177 / 2485 / 1361 (AFIP) - Factura Electrónica {br} El crédito fiscal discriminado en el presente comprobante, sólo podrá ser computado a efectos del Régimen de Sostenimiento e Inclusión Fiscal para Pequeños Contribuyentes de la Ley No 27.618",
  },

  default: {
    id: `${scope}.default`,
    defaultMessage: "",
  },
});
